const pick = (object, keys) => {
  if (!object || typeof object !== 'object') {
    throw new TypeError('Expected an object as the first argument')
  }

  if (!Array.isArray(keys)) {
    throw new TypeError('Expected an array of keys as the second argument')
  }

  return keys.reduce((acc, key) => {
    if (key in object) {
      return { ...acc, [key]: object[key] }
    }
    return acc
  }, {})
}

export default pick
